// 관리자 Zustand 스토어
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdminUser {
  id: number;
  username: string;
  email: string;
  role: string;
}

interface AdminState {
  admin: AdminUser | null;
  token: string | null;
  isAuthenticated: boolean;

  setAdmin: (admin: AdminUser, token: string) => void;
  logout: () => void;
  checkAuth: () => void;
}

export const useAdminStore = create<AdminState>()(
  persist(
    (set) => ({
      admin: null,
      token: null,
      isAuthenticated: false,

      setAdmin: (admin, token) => {
        localStorage.setItem('adminToken', token); // For impersonate feature
        localStorage.setItem('admin_token', token);
        localStorage.setItem('admin_user', JSON.stringify(admin));
        set({ admin, token, isAuthenticated: true });
      },

      logout: () => {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        set({ admin: null, token: null, isAuthenticated: false });
      },

      checkAuth: () => {
        const token = localStorage.getItem('admin_token');
        const adminStr = localStorage.getItem('admin_user');

        if (token && adminStr) {
          try {
            const admin = JSON.parse(adminStr);
            set({ admin, token, isAuthenticated: true });
          } catch {
            set({ admin: null, token: null, isAuthenticated: false });
          }
        } else {
          set({ admin: null, token: null, isAuthenticated: false });
        }
      },
    }),
    {
      name: 'admin-storage',
    }
  )
);
